{
	"cardTitle": "Por su seguridad, su sesión ha caducado.",
	"loginButtonLabel": "Volver a iniciar sesión"
}
